
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M20.7 8.74c-4.82-4.819-12.66-4.819-17.48 0L0 11.96l3.3 3.299a12.323 12.323 0 008.74 3.615c3.166 0 6.33-1.205 8.741-3.615l3.22-3.22-3.3-3.298zm-.493 5.946c-4.503 4.503-11.83 4.503-16.335 0L1.146 11.96l2.647-2.646c4.503-4.503 11.83-4.503 16.335 0l2.726 2.726-2.647 2.646z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M11.583 8.745a2.84 2.84 0 00-2.838 2.837.406.406 0 00.811 0 2.03 2.03 0 012.027-2.027.406.406 0 000-.81z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M11.989 6.718a5.276 5.276 0 00-5.27 5.27 5.276 5.276 0 005.27 5.27 5.276 5.276 0 005.27-5.27 5.276 5.276 0 00-5.27-5.27zm0 9.73c-2.46 0-4.46-2.001-4.46-4.46s2-4.46 4.46-4.46c2.458 0 4.46 2.001 4.46 4.46s-2.001 4.46-4.46 4.46z","fill":"#00003C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    